<template>
    <div class="modal-card" style="width: auto; min-width: 680px">
        <header class="modal-card-head">
            <p class="modal-card-title">
                {{appointment.Subject}}
            </p>
        </header>
        <section class="modal-card-body">
            <div>
                <div>
                    <div>
                        <b>{{moment(appointment?.Start).format('dddd')}}</b>
                    </div>
                    <div>
                        <span v-if="!appointment?.IsAllDay">{{moment(appointment?.Start).format('h:mma')}} - {{moment(appointment?.End).format('h:mma')}}</span>
                        <span v-else>All Day</span>
                    </div>
                    <div v-if="appointment.Location">
                        at {{appointment.Location}}
                    </div>
                </div>
                <hr />
                <loading v-if="loading"></loading>
                <div class="my-5" v-else>
                    <div v-html="$sanitize(body)"></div>
                    <div class="my-5">
                        <div class="is-flex" v-if="loading_attachments || !loading_attachments && attachments.length > 0">
                            <loading v-if="loading_attachments"></loading>
                            <template v-else>
                                <div v-for="file in attachments" :key="file.Id" :class="{'attachment-block' : true, 'is-clickable': true, 'is-downloading': file.downloading}" @click="DownloadAttachment(file)">
                                    <div><fa-icon icon="file-export" size="lg" class="attachment-file-icon"></fa-icon></div>
                                    <p>
                                        {{file.Name}}
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <o-button variant="light" @click="Close">Cancel</o-button>
        </footer>
    </div>
</template>
<script>
    import { ref, inject, onMounted } from "vue";

    export default {
        props: {
            appointment: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        setup(props, context) {
            const http = inject("$http");
            const moment = inject("$moment");

            const loading = ref(true);
            const loading_attachments = ref(true);
            const body = ref();
            const attachments = ref([]);

            const GetBody = async () => {
                try {
                    const response = await http.post("/api/v2/widget/calendar/body", props.appointment);
                    body.value = response.data.Text;
                    loading.value = false;
                }
                catch (err) {
                    console.error(err);
                }
            };

            const GetAttachments = async () => {
                try {
                    const response = await http.post("/api/v2/widget/calendar/attachments", props.appointment);
                    attachments.value = response.data;
                    loading_attachments.value = false;
                }
                catch (err) {
                    console.error(err);
                }
            };

            const DownloadAttachment = async (file) => {
                if (!file.downloading) {
                    file.downloading = true;
                    try {
                        const response = await http.post("/api/v2/widget/calendar/attachments/" + encodeURIComponent(file.Id) + "/download", props.appointment, { responseType: 'arraybuffer'});
                        download(file.Name, response);
                    }
                    catch (err) {
                        console.error(err);
                    }
                    file.downloading = false;
                }
            }

            function download(filename, response) {
                const file = new Blob([response.data], { 'type': "" });

                const url = window.URL.createObjectURL(file);
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.setAttribute("href", url);
                a.setAttribute("download", filename);
                a.style.visibility = "hidden";
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }

            const Close = () => {
                context.emit("close");
            };

            onMounted(() => {
                GetBody();
                GetAttachments();
            });

            return {
                moment,
                loading,
                loading_attachments,
                body,
                attachments,
                GetBody,
                DownloadAttachment,
                Close
            };
        }
    }

</script>
<style lang="scss">
    .attachment-block {
        font-size: 26px;
        padding: 24px;
        border-radius: 4px;
        border: 1px solid rgb(128, 128, 128, 0.4);
        display: flex;
        flex-flow: row wrap;
        gap: 1em;

        & .attachment-file-icon {
            margin: auto;
            display: block;
        }
    }

    .is-downloading {
        cursor: not-allowed !important;
        opacity: 0.5;
    }
</style>
